import cn from 'classnames';
import ScrollTopButton from 'components/Common/ScrollTopButton/ScrollTopButton';
import { debounce } from 'lodash';
import React, { useEffect } from 'react';
import { useAppDispatch } from 'store';
import detectCustomerDeviceOperation from 'store/app/operation/detectCustomerDeviceOperation';
import styles from './Layout.module.scss';

export interface OwnProps {
  itemType?: string;
  itemScope?: boolean;
  className?: string;
  children: any;
  showScrollTop?: boolean;
  prefix?: JSX.Element;
}

const Layout = ({ children, itemType, itemScope, className, prefix, showScrollTop = true }: OwnProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const windowResizeListener = () => {
      dispatch(detectCustomerDeviceOperation());
    };
    const windowResizeListenerDebounce = debounce(windowResizeListener, 300);

    windowResizeListenerDebounce();
    window.addEventListener('resize', windowResizeListenerDebounce);

    return () => {
      window.removeEventListener('resize', windowResizeListenerDebounce);
    };
  }, []);

  return (
    <>
      {prefix}
      <div className={cn(styles.opLayout, className || '')} itemType={itemType} itemScope={itemScope}>
        <div className={styles.content}>{children}</div>
        {showScrollTop && <ScrollTopButton />}
      </div>
    </>
  );
};

export default Layout;
